module.exports = __WEBPACK_EXTERNAL_MODULE_11__;


//////////////////
// WEBPACK FOOTER
// external "oasi-bpm-history/dist/oasiBpmHistory.css"
// module id = 11
// module chunks = 0